import React from 'react'

function Festival() {
  return (
    <div>Festival</div>
  )
}

export default Festival